import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, ShieldCheck, Lock } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy text-white py-6 px-4 md:px-6 relative overflow-hidden min-h-[80svh] flex flex-col justify-center" data-id="element-153">
      <div className="max-w-4xl mx-auto text-center relative z-10 w-full" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-155">
          <div className="inline-flex items-center gap-2 bg-white/10 px-3 py-1.5 rounded-full text-gold font-semibold text-xs md:text-sm mb-2 border border-gold/20" data-id="element-156">
            <span className="text-base" data-id="element-157">🏆</span> CHERUB AGENCY™
          </div>

          <h1 className="font-display md:text-4xl lg:text-5xl font-bold mb-1 md:mb-2 text-[28px]" data-id="element-158">
            Todo lo que necesitas para ayudar a tu hijo con TDAH.
          </h1>

          <p className="text-gold-light font-display text-lg md:text-2xl font-semibold mb-3 md:mb-4" data-id="element-159">
            Listo. Desde hoy.
          </p>

          {/* Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mb-3 md:mb-4" data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/n2Ry5FFzPdaA7PdnWbSwSV/a764c523-3e06-46ff-9653-546e315567a8.png" alt="TDAH: El Sistema Definitivo - 10 Tomos del MegaPack Completo" className="w-full max-w-2xl mx-auto rounded-lg shadow-2xl object-contain max-h-[25vh] md:max-h-[35vh]" data-id="element-161" />
          </motion.div>

          <div className="bg-white/5 border border-white/10 rounded-xl p-3 md:p-4 mb-3 max-w-3xl mx-auto backdrop-blur-sm" data-id="element-162">
            <h2 className="md:text-2xl font-bold text-white mb-1 text-[16px]" data-id="element-163"></h2>
            <p className="text-gold md:text-lg font-semibold mb-2 text-[20px]" data-id="element-164">
              El sistema N°1 para padres de niños con TDAH — De la crisis al
              éxito
            </p>
            <p className="text-gray-300 md:text-base text-[14px]" data-id="element-165">
              Otros padres improvisan. Tú no. Rutinas que funcionan, límites sin
              gritos y deberes sin pelea. Todo listo para aplicar hoy.
            </p>
          </div>

          <motion.button whileHover={{
          scale: 1.05,
          filter: 'brightness(1.1)'
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToPricing} className="bg-gold text-navy font-bold text-base md:text-lg px-6 py-3 rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.3)] hover:shadow-[0_0_40px_rgba(201,168,76,0.5)] transition-all w-full md:w-auto flex items-center justify-center gap-2 mx-auto mb-3" data-id="element-166">
            <span className="text-xl" data-id="element-167">💪</span> → QUIERO MI MEGAPACK AHORA
          </motion.button>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-sm md:text-base font-medium text-gray-200 mb-3" data-id="element-168">
            <div className="flex items-center gap-1.5 text-[12px]" data-id="element-169">
              <FileText className="w-4 h-4 text-gold" data-id="element-170" /> 100% PDF
            </div>
            <div className="flex items-center gap-1.5 text-[12px]" data-id="element-171">
              <Zap className="w-4 h-4 text-gold" data-id="element-172" /> Acceso en 5 min
            </div>
            <div className="flex items-center gap-1.5 text-[12px]" data-id="element-173">
              <BookOpen className="w-4 h-4 text-gold" data-id="element-174" /> Todos los niveles
            </div>
            <div className="flex items-center gap-1.5 text-[12px]" data-id="element-175">
              <ShieldCheck className="w-4 h-4 text-gold" data-id="element-176" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1.5 text-[12px]" data-id="element-177">
              <Lock className="w-4 h-4 text-gold" data-id="element-178" /> Pago seguro
            </div>
          </div>
        </motion.div>
      </div>

      {/* Subtle background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-6xl h-full overflow-hidden pointer-events-none opacity-20" data-id="element-179">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-gold blur-[120px]" data-id="element-180"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[50%] rounded-full bg-gold blur-[120px]" data-id="element-181"></div>
      </div>
    </section>;
}